/*
 * File: ContactCard.tsx
 * Project: a-a
 * File Created: Wednesday, 8th January 2025 11:04:48 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 21st July 2025 1:35:15 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import CustomCard from '../../CustomCard/CustomCard';
import zeplinColor from '../../../../theme/Color';
import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';

const ContactCard = ({
  data,
  setSelected,
  selected,
  loading,
}: {
  data: any;
  setSelected: React.Dispatch<React.SetStateAction<any>>;
  selected: any;
  loading: boolean;
}) => {
  const theme = useTheme();
  const name = data?.name?.split(' ');
  const handleSelected = (val: any) => {
    setSelected(val);
  };
  return (
    <Box onClick={() => handleSelected(data)}>
      <CustomCard
        styles={{
          // borderRadius: '14px',
          padding: '18px',
          heigth: '93px',
          backgroundColor: zeplinColor.Neutral1,
          borderWidth: `1px 1px 1px 1px`,
          borderStyle: 'solid',
          borderColor: `${
            selected?.name === data?.name && !loading
              ? zeplinColor.BasicBlack
              : zeplinColor.Neutral5
          }`,
          borderRadius: '14px',
          display: 'flex',
          // flexDirection: 'column',
          gap: '12px',
          alignItems: 'center',
          cursor: 'pointer',
          // justifyContent: 'space-between',
        }}
      >
        {loading ? (
          <Skeleton variant='rounded' width={68} height={68} />
        ) : (
          <Box
            sx={{
              borderRadius: { xs: '12px', xl: '14px' },
              // padding: '10px',
              width: { xs: '40px', xl: '68px' },
              height: { xs: '40px', xl: '68px' },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

              gap: '10px',
              backgroundColor:
                // (index + 1) % 3 === 1
                //   ? zeplinColor.Blue3
                //   : index % 3 === 2
                //   ? zeplinColor.Green1
                zeplinColor.Brand1,
            }}
          >
            <Typography
              variant='responsiveDisplay5'
              color={zeplinColor.Neutral1}
              sx={{ textAlign: 'center' }}
            >
              {name?.map((value: any, index: number) =>
                index === 0 || index === name.length - 1 ? value[0] : '',
              )}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: '8px',
            flex: 1,
          }}
        >
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveHeading4' style={{ textAlign: 'left' }}>
              {data?.name}
            </Typography>
          )}
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Box
              sx={{
                display: 'flex',
                // justifyContent: 'space-between',

                gap: '8px',
              }}
            >
              <a
                href='mailto:traviskelce@gmail.com'
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none' }}
              >
                {data?.email}
              </a>
            </Box>
          )}
        </Box>
        {data?.roles && (
          <Chip
            label={
              <Typography variant='responsiveLabel1' sx={{ display: 'flex', alignItems: 'center' }}>
                {data?.roles}
              </Typography>
            }
            sx={{
              bgcolor: zeplinColor.BasicBlack,
              // Constants.PriorityTask[(data?.priority || 'Medium') as 'Normal' | 'Low' | 'High'],
              color: zeplinColor.Neutral1,
              // width: '39px',
              '&.MuiChip-root': {
                height: '22px',
                padding: '4px 8px',
                borderRadius: '50px',
              },
              '& .MuiChip-label': {
                padding: 0,
              },
            }}
          />
        )}
      </CustomCard>
    </Box>
  );
};

export default ContactCard;
